//-- Copyright (c) 2021 TMT Insights Group, LLC
import styled from '@emotion/styled';
import { Box, BoxProps, Typography, TypographyProps } from '@mui/material';
import { ReactNode } from 'react';

type SectionHeadingProps = BoxProps & {
  icon?: ReactNode;
  variant?: TypographyProps['variant'];
  children: ReactNode;
  color?: TypographyProps['color'];
  sx?: BoxProps['sx'];
};

const SectionHeading = ({ icon, variant = 'h2', children, color = 'primary', sx }: SectionHeadingProps) => (
  <Heading sx={sx}>
    <Typography variant={variant} sx={{ color: `${color}.main` }}>
      {icon && <HeadingIcon>{icon}</HeadingIcon>}
      {children}
    </Typography>
  </Heading>
);

export default SectionHeading;

const Heading = styled(Box)`
  display: flex;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing(2)};
  font-size: 1.33rem;
  line-height: 1.5;

  & .MuiTypography-root,
  & svg {
    display: flex;
    align-items: center;
    font-size: 1.33rem;
    font-weight: 500;
  }
`;

const HeadingIcon = styled.span`
  margin-right: ${({ theme }) => theme.spacing(1)};
  line-height: 1;
  display: inline-flex;
`;
